export default class MeterCodes {

  /**
   * QH Gesamte gemeinschaftliche Erzeugung
   * @returns {string}
   */
  static get producerProductionTotal() {
    return "1-1:2.9.0 G.01";
  }

  /** starting with 08.04.2024 (MFT Mehrfachteilnahme)
   *
   * Restnetzüberschuss bei Energiegemeinschaft
   * @returns {string} - Meter code
   */
  static get producerProductionRemainderMft() {
    return "1-1:2.9.0 P.01T";
  }

  /**
   * Verbrauch laut Messung entsprechend dem Teilnahmefaktor bei der EG und je ZP
   * @returns {string}
   */
  static get memberConsumptionForCommunityMft() {
    return "1-1:1.9.0 G.01T";
  }

  /**
   * Erzeugung laut Messung entsprechend dem Teilnahmefaktor bei der EG und je ZP
   * @returns {string} - Meter code
   */
  static get memberProductionForCommunityMft() {
    return "1-1:2.9.0 G.01T";
  }

  /** unused currently
   *
   * Eigendeckung aus erneuerbarer Energie
   * @returns {string} - Meter code
   */
  static get memberShareEffectiveRenewable() {
    return "1-1:2.9.0 G.03R";
  }

  /** October'22 to April'24
   * should match memberShareEffective in community if only one producer
   *
   * QH/D Lastgang 1⁄4 h Wirkenergiewerte Bezug vom Endkunden errechneter Überschuss
   * @returns {string}
   */
  static get producerProductionRemainder() {
    return "1-1:2.9.0 P.01";
  }


  /** base since 2019 (GEAs und 2021 EEGs)
   * QH Gesamtverbrauch lt. Messung (bei Teilnahme gem. Erzeugung)
   * @returns {string} - Meter code
   */
  static get memberConsumptionTotal() {
    return "1-1:1.9.0 G.01";
  }

  /**
   * QH Anteil gemeinschaftliche Erzeugung (unused)
   * @returns {string} - Meter code
   */
  static get memberShareAvailable() {
    return "1-1:2.9.0 G.02";
  }

  /**
   * QH Eigendeckung gemeinschaftliche Erzeugung
   * @returns {string} - Meter code
   */
  static get memberShareEffective() {
    return "1-1:2.9.0 G.03";
  }

  /** currently assumed (assumption was wrong) - used in 4wardEnergy data sets
   *
   * QH inverse Eigendeckung
   * @returns {string} - Meter Code
   */
  static get producerShareEffective() {
    return "1-1:3.9.0 G.03";
  }
}
